<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 生产管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>任务管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <!-- <el-col :span="6">
              <el-form-item label="任务名称" prop="task_name">
                <el-input v-model="searchform.task_name" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="任务状态">
                <el-select v-model="searchform.task_status" style="width:100%" placeholder="请选择">
                  <el-option
                    v-for="item in task_status"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="任务类型" prop="task_type">
                <el-select v-model="searchform.task_type" style="width:100%" placeholder="请选择">
                  <el-option
                    v-for="item in task_type"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                v-permission="['taskmanagement_select']"
              >搜索</el-button>
              <el-button
              v-permission="['taskmanagement_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
              >导出Excel</el-button>
              <el-button type="primary" v-permission="['taskmanagement_add']" @click="addstart()">新增任务</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>任务管理列表</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
            @cell-click="danhang"
          >
            <el-table-column prop="task_name" label="任务名称" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="task_type" label="任务类型" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="task_status" label="任务状态" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="task_source" label="任务来源" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="task_field" label="任务关键字1" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column
              prop="task_field1"
              label="任务关键字2"
              min-width="150"
              show-overflow-tooltip
            ></el-table-column>
                        <el-table-column
              prop="task_field2"
              label="任务关键字3"
              min-width="150"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="task_desc" label="任务描述" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" min-width="100" show-overflow-tooltip fixed="right">
              <template scope="scope">
                <el-button
                  type="danger"
                  v-show="scope.row.task_status =='失败'"
                  size="mini"
                  v-permission="['taskmanagement_update']"
                  @click="update()"
                  plain
                >重启任务</el-button>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
      <!-- 修改弹窗 -->
      <el-dialog
        title="新增任务"
        :visible.sync="editVisible"
        width="28%"
        @close="resetForm('form')"
        center
      >
        <el-form :model="form" ref="form" label-width="150px" :rules="rules">
          <el-row>
            <el-form-item label="任务类型" >
              <el-select v-model="form.tasktype" style="width:100%" placeholder="请选择任务类型" @change="resetForm('form')">
                <el-option
                  v-for="item in task_type"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关键字1（订单号）" prop="orderno" v-show="form.tasktype == 3">
              <el-input v-model="form.orderno" style="width:100%"></el-input>
            </el-form-item>

            <el-form-item label="关键字2（批次号）" prop="batchno" v-show="form.tasktype == 3">
              <el-input v-model="form.batchno" style="width:100%"></el-input>
            </el-form-item>
            <el-form-item label="关键字3（产品编码）" prop="product_code" v-show="form.tasktype == 3">
              <el-input v-model="form.product_code" style="width:100%"></el-input>
            </el-form-item>
            <el-form-item
              label="关键字1（码）"
              prop="qrcode"
              v-show="form.tasktype <= 2 && form.tasktype > 0"
            >
              <el-input v-model="form.qrcode" style="width:100%"></el-input>
            </el-form-item>

            <el-form-item
              label="关键字2（新码）"
              prop="qrcodenew"
              v-show="form.tasktype == 1"
            >
              <el-input v-model="form.qrcodenew" style="width:100%"></el-input>
            </el-form-item>
            <el-form-item
              label="包装级别"
              prop="level"
              v-show="form.tasktype == 2 || form.tasktype == 1"
            >
              <el-select v-model="form.level" style="width:100%" placeholder="请选择任务类型">
                <el-option
                  v-for="item in level"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="resetForm('form'),editVisible = false">取 消</el-button>
          <el-button @click="resetForm('form')" plain>重置</el-button>
          <el-button type="primary" @click="addstartpost('form')">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { tasklist, taskstart, startagain } from "@/api/plant";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.search();
  },
  data() {
    return {
      //基础数据
      editVisible: false,
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      // 搜索下拉
      task_type: [
        {
          value: 1,
          label: "替换"
        },
        {
          value: 2,
          label: "解除"
        },
        {
          value: 3,
          label: "按批次解除"
        }
      ],
      task_status: [
        {
          value: 0,
          label: "未开始"
        },
        {
          value: 1,
          label: "进行中"
        },
        {
          value: 2,
          label: "成功"
        },
        {
          value: 3,
          label: "失败"
        },
        {
          value: 4,
          label: "取消"
        }
      ],
      level: [
        {
          value: 1,
          label: "一级包装"
        },
        {
          value: 2,
          label: "二级包装"
        },
         {
          value: 3,
          label: "三级包装"
        },
        {
          value: 4,
          label: "四级包装"
        },
         {
          value: 5,
          label: "五级包装"
        },
      ],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //搜索表单数据
      searchform: {
        datelist: [],
        task_type: null,
        task_name: null,
        task_status: 1,
        currPage: 1,
        pageSize: 10
      },
      // 修改表单
      form: {
        product_code:null,
        orderno: null,
        batchno: null,
        tasktype: null,
        qrcode: null,
        qrcodenew: null,
        level: 1,
        task_id: null
      },
      //基础表单验证
      rules: {
        task_type: [
          { required: true, message: "请输入任务类型", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      tasklist(obj).then(response => {
        this.tableData = response.data.data;
        this.packdate(this.tableData);
        this.total_count = response.data.total_count;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    // 拼数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        switch (obj[i].task_type) {
          case 1:
            obj[i].task_type = "替换";
            break;
          case 2:
            obj[i].task_type = "解除";
            break;
          case 3:
            obj[i].task_type = "按批次解除";
            break;
          default:
            break;
        }
        switch (obj[i].task_status) {
          case 0:
            obj[i].task_status = "未开始";
            break;
          case 1:
            obj[i].task_status = "进行中";
            break;
          case 2:
            obj[i].task_status = "成功";
            break;
          case 3:
            obj[i].task_status = "失败";
            break;
          case 4:
            obj[i].task_status = "取消";
            break;
          default:
            break;
        }
        switch (obj[i].task_source) {
          case 0:
            obj[i].task_source = "web网页";
            break;
          case 1:
            obj[i].task_source = "工控机";
            break;
          default:
            break;
        }
      }
    },
    //搜索事件
    search() {
      this.Tabledata({
        task_type: this.searchform.task_type,
        task_name: this.searchform.task_name,
        task_status: this.searchform.task_status,
        pageSize: this.searchform.pageSize
      });
    },
    //重置按钮
    resetForm(formName) {
      if (this.form.tasktype==1 || this.form.tasktype==4 ) {
        this.form.level =1;
      }
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage;
      this.Tabledata({
        task_type: this.searchform.task_type,
        task_name: this.searchform.task_name,
        task_status: this.searchform.task_status,
        pageSize: this.searchform.pageSize,
        pageIndex: this.searchform.currPage
      });
      console.log(currPage);
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize;
      this.search();
    },
    //表格单行点击
    danhang(row) {
      this.form.task_id = row.task_id;
      console.log(this.rowdate);
    },
    //新增窗口
    addstart(obj) {
      this.editVisible = true;
    },
    addstartpost(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          taskstart({
            product_code:this.form.product_code,
            orderno: this.form.orderno,
            batchno: this.form.batchno,
            tasktype: this.form.tasktype,
            qrcode: this.form.qrcode,
            qrcodenew: this.form.qrcodenew,
            level: this.form.level
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "新增成功!"
              });
              this.Tabledata();
              this.editVisible = false;
            } else {
              this.$message({
                type: "woring",
                message: "新增失败!服务器出错"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //重启按钮事件
    update() {
      this.$confirm("此操作将重启该任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          startagain({
            task_id: this.form.task_id
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "重启成功!"
              });
              this.Tabledata();
            } else {
              this.$message({
                type: "woring",
                message: "重启失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消重启"
          });
        });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
        task_type: this.searchform.task_type,
        task_name: this.searchform.task_name,
        task_status: this.searchform.task_status,
      };
      tasklist(obj).then(response => {
        this.packdate(response.data.data)
        this.tableDataDownload = response.data.data;
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "任务名称",
            "任务类型",
            "任务状态",
            "任务来源",
            "任务关键字1",
            "任务关键字2",
            "任务关键字3",
            "任务描述",
          ];
          const filterVal = [
            "task_name",
            "task_type",
            "task_status",
            "task_source",
            "task_field",
            "task_field1",
            "task_field2",
            "task_desc",
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
</style>